import { ENHANCE_TYPE } from './type';

export const parameter = {
    [ENHANCE_TYPE.SD]: {
        sr_mode: 2,
        ir_mode: 4,
        rsp_media_type: 'url',
        max_width: 8000,
        max_height: 8000,
    },
    [ENHANCE_TYPE.HD]: {
        sr_mode: 1,
        ir_mode: 4,
        rsp_media_type: 'url',
        max_width: 8000,
        max_height: 8000,
        sr_num: 2,
    },
    [ENHANCE_TYPE.HDU]: {
        sr_mode: 1,
        ir_mode: 4,
        rsp_media_type: 'url',
        max_width: 8000,
        max_height: 8000,
        sr_num: 4,
    },
};
